/*/
 * Fancybox v4
 *
 * data-fancybox + group-name
 *
/*/
	import { Fancybox } from "@fancyapps/ui"

	Fancybox.bind('[data-fancybox]', {
		infinite: false,
		Carousel: {
			Navigation: {
				prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M11 5l-7 7 7 7"/><path d="M4 12h16"/></svg>',
				nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M4 12h16"/><path d="M13 5l7 7-7 7"/></svg>',
			},
		},
		Toolbar: {
			display: [
				"counter",
				"slideshow",
				"thumbs",
				"close",
			],
			items: {
				counter: {
					type: "div",
					class: "fancybox__counter",
					html: '<span data-fancybox-index=""></span>&nbsp;/&nbsp;<span data-fancybox-count=""></span>',
					tabindex: -1,
					position: "left",
				},
				slideshow: {
					type: "button",
					class: "fancybox__button--slideshow",
					label: "TOGGLE_SLIDESHOW",
					html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><g><path d="M6 4v16"/><path d="M20 12L6 20"/><path d="M20 12L6 4"/></g><g><path d="M7 4v15M17 4v15"/></g></svg>`,
					click: function (event) {
						event.preventDefault();
						this.Slideshow.toggle();
					},
				},
				zoom: {
					type: "button",
					class: "fancybox__button--zoom",
					label: "TOGGLE_ZOOM",
					html: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><circle cx="10" cy="10" r="7"></circle><path d="M16 16 L21 21"></svg>',
					click: function (event) {
						event.preventDefault();
						const panzoom = this.fancybox.getSlide().Panzoom;
						if (panzoom) {
							panzoom.toggleZoom();
						}
					},
				},
				thumbs: {
					type: "button",
					label: "TOGGLE_THUMBS",
					class: "fancybox__button--thumbs",
					html: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><circle cx="4" cy="4" r="1" /><circle cx="12" cy="4" r="1" transform="rotate(90 12 4)"/><circle cx="20" cy="4" r="1" transform="rotate(90 20 4)"/><circle cx="4" cy="12" r="1" transform="rotate(90 4 12)"/><circle cx="12" cy="12" r="1" transform="rotate(90 12 12)"/><circle cx="20" cy="12" r="1" transform="rotate(90 20 12)"/><circle cx="4" cy="20" r="1" transform="rotate(90 4 20)"/><circle cx="12" cy="20" r="1" transform="rotate(90 12 20)"/><circle cx="20" cy="20" r="1" transform="rotate(90 20 20)"/></svg>',
					click: function (event) {
						event.stopPropagation();
						const thumbs = this.fancybox.plugins.Thumbs;
						if (thumbs) {
							thumbs.toggle();
						}
					},
				},
				close: {
					type: "button",
					label: "CLOSE",
					class: "fancybox__button--close",
					html: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"></path></svg>',
					tabindex: 1,
					click: function (event) {
						event.stopPropagation();
						event.preventDefault();
						this.fancybox.close();
					},
				},
			}
		},
		Thumbs: {
			autoStart: true,
		},
		Hash: false,
		l10n: {
			CLOSE: "Fechar",
			NEXT: "Próxima",
			PREV: "Anterior",
			MODAL: "Você pode fechar essa modal pressionando ESC",
			ERROR: "Algo deu errado. Tente Novamente.",
			IMAGE_ERROR: "Imagem não encontrada",
			ELEMENT_NOT_FOUND: "Elemento HTML não encontrado",
			AJAX_NOT_FOUND: "Erro ao carregar AJAX : Não encontrado",
			AJAX_FORBIDDEN: "Erro ao carregar AJAX : Acesso restrito",
			IFRAME_ERROR: "Erro ao carregar página",
		}
	})
